export default {
    mounted() {
        this.$root.store.sideMenu = [];
    },
};
